import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { authSignOut } from "../../redux/auth/authActions";


const ProfilePage = ({ auth, authSignOut }) => {
    const handleSignOut = async () => await authSignOut();
    return (
        <>
            <div className="flex justify-center items-center">

                <div className="w-full bg-blue-500 py-5 backdrop-filter backdrop-blur-lg bg-opacity-20 hover:bg-opacity-20 overflow-hidden shadow">
                    <div className="flex justify-center">
                        <img src={auth.user.photoURL} className="rounded-full border-solid border-white border-2" alt=""/>		
                    </div>
                    <div className="text-center px-3 pb-6 pt-2">
                        <h3 className="text-white text-sm bold font-sans">{auth.user.displayName}</h3>
                        {/* <p className="mt-2 font-sans font-light text-white">Hello, i'm from another the other side!</p> */}
                    </div>
                    {/* <div className="flex justify-center pb-3 text-white">
                        <div className="text-center mr-3 border-r pr-3">
                            <h2>34</h2>
                            <span>Photos</span>
                        </div>
                        <div className="text-center">
                            <h2>42</h2>
                            <span>Friends</span>
                        </div>
                    </div> */}
                    <div className="flex space-x-2 justify-center pb-3 text-white">
                        <button className="inline-flex justify-center items-center px-4 py-1 border border-transparent text-center leading-6 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:border-blue-700 focus:shadow-outline-blue active:bg-blue-700 transition ease-in-out duration-150" onClick={() => handleSignOut()}>Sign out</button>
                    </div>
                </div>
                
            </div>

            <div className="">
                <Link to="/admins">
                    <div className="flex justify-center items-center bg-blue-500 m-3 p-3 rounded-full backdrop-filter backdrop-blur-lg bg-opacity-20 hover:bg-opacity-40 overflow-hidden shadow hover:shadow-lg text-gray-400 hover:text-gray-300">
                        <div className="w-1/6">
                            <span className="material-icons-outlined rounded-full p-2 bg-blue-900 backdrop-filter backdrop-blur-lg bg-opacity-20 hover:bg-opacity-20">people_alt</span>
                        </div>
                        <div className="w-4/6 text-xl">
                            <h2>Admins</h2>
                        </div>
                        <div className="w-1/6 text-right">
                            <span className="material-icons-outlined p-2">arrow_forward</span>
                        </div>
                    </div>
                </Link>
                <Link to="/users">
                    <div className="flex justify-center items-center bg-blue-500 m-3 p-3 rounded-full backdrop-filter backdrop-blur-lg bg-opacity-20 hover:bg-opacity-40 overflow-hidden shadow hover:shadow-lg text-gray-400 hover:text-gray-300">
                        <div className="w-1/6">
                            <span className="material-icons-outlined rounded-full p-2 bg-blue-900 backdrop-filter backdrop-blur-lg bg-opacity-20 hover:bg-opacity-20">people_alt</span>
                        </div>
                        <div className="w-4/6 text-xl">
                            <h2>Users</h2>
                        </div>
                        <div className="w-1/6 text-right">
                            <span className="material-icons-outlined p-2">arrow_forward</span>
                        </div>
                    </div>
                </Link>
                <Link to="/payment-settings">
                    <div className="flex justify-center items-center bg-blue-500 m-3 p-3 rounded-full backdrop-filter backdrop-blur-lg bg-opacity-20 hover:bg-opacity-40 overflow-hidden shadow hover:shadow-lg text-gray-400 hover:text-gray-300">
                        <div className="w-1/6">
                            <span className="material-icons-outlined rounded-full p-2 bg-blue-900 backdrop-filter backdrop-blur-lg bg-opacity-20 hover:bg-opacity-20">payment</span>
                        </div>
                        <div className="w-4/6 text-xl">
                            <h2>Payment Settings</h2>
                        </div>
                        <div className="w-1/6 text-right">
                            <span className="material-icons-outlined p-2">arrow_forward</span>
                        </div>
                    </div>
                </Link>
            </div>
                
        </>
    );
}
 

const mapStateToProps = state => {
    return {
        auth: state.auth
    };
}


const mapDispatchToProps = dispatch => {
    return {
        authSignOut: () => dispatch(authSignOut()),
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(ProfilePage);